import { openaiCache } from '../cache-service';
import { performMigration, checkMigrationRequired } from '../cache-migration';
import { getProjects, getUsers, getProjectUsers, getProjectApiKeys } from './endpoints';
import { debugLog } from '../debug-log';
import type { OrganizationData } from './types';

/**
 * 全ての組織データを一括取得
 */
export const getAllOrganizationData = async (apiKey: string) => {
  // Check if migration is required and perform it
  if (checkMigrationRequired()) {
    debugLog('Migrating cache to IndexedDB...');
    await performMigration();
  }

  // キャッシュの確認
  const cachedData = await openaiCache.getOrganizationData();
  if (cachedData) {
    debugLog('Returning cached organization management data from IndexedDB.');
    return cachedData;
  }

  const [projectsResponse, usersResponse] = await Promise.all([
    getProjects(apiKey, true),
    getUsers(apiKey),
  ]);

  const results: OrganizationData = {
    projects: projectsResponse,
    users: usersResponse,
    projectDetails: [],
  };

  // プロジェクトごとの詳細データを取得
  if (projectsResponse.success && projectsResponse.data) {
    const projectDetailsPromises = projectsResponse.data.data.map(async (project) => {
      const [usersRes, apiKeysRes] = await Promise.all([
        getProjectUsers(apiKey, project.id),
        getProjectApiKeys(apiKey, project.id),
      ]);

      return {
        project,
        users: usersRes.success ? usersRes.data?.data || [] : [],
        apiKeys: apiKeysRes.success ? apiKeysRes.data?.data || [] : [],
      };
    });

    results.projectDetails = await Promise.all(projectDetailsPromises);
  }

  // IndexedDBキャッシュに保存
  await openaiCache.cacheOrganizationData(results);
  debugLog('Organization management data cached to IndexedDB.');

  return results;
};
